<template lang="pug">
  include ./../../mixins
  +b.order
    +b.H2.caption.--size_2 {{ _("Order Creation. Responce") }}
    +e.content
      +b.copy
        +e.field
          +e.P.content {{ orderLink }}
        +e.button(
          @click.prevent="copyOrderLink"
          ref="copyButton"
        )
          +b.I.icon.--type_copy
</template>
<script>
export default {
  props: {
    orderLink: String,
  },
  data() {
    return {}
  },
  methods: {
    copyOrderLink() {
      const timeout = 1500
      this.$copyText(this.orderLink).then((e) => {
        this.$refs.copyButton.classList.add('is-success')
        setTimeout(() => {
          this.$refs.copyButton.classList.remove('is-success')
        }, timeout)
      }, (e) => {
        this.$refs.copyButton.classList.add('is-error')
        setTimeout(() => {
          this.$refs.copyButton.classList.remove('is-error')
        }, timeout)
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/Order/OrderResponse.vue